import React, { Component } from 'react';
import { toast } from 'react-toastify';
import Mensagem from '../../common/Mensagem'
import api from '../../services/api';
import { Link } from 'react-router-dom'
import InputMask from 'react-input-mask';
import { validate, format, generate } from 'cnpj';
const { cpf } = require('cpf-cnpj-validator');

class Registro extends Component {
    
    constructor(props){
        super(props);

        this.state = {
            nome:'',
            senha:'',
            confirma:''
        }

        this.handleLogin = this.handleLogin.bind(this);
        this.handleRegistrar = this.handleRegistrar.bind(this);
        
    }

    async componentDidMount() {

    }

    
    handleLogin = async (event) => {
        event.preventDefault();
        this.props.history.push('/login');
    }     

    handleRegistrar = async (event) => {
        event.preventDefault();
        
        const { nome, senha, confirma } = this.state;
        
        if( !nome ) return toast.error("Nome é obrigatório!");
        if( !senha ) return toast.error("Senha é obrigátorio.");
        if( !confirma ) return toast.error("Senha é obrigátorio.");
        if( senha != confirma ) return toast.error("Senha divergente da outra.");
        try {

            const token    = sessionStorage.getItem('token');
        
            
            await api.post('/api/registro',{ nome, senha }, {
                headers: {
                    'x-access-token':token,
                }

            }).then(response => {
                
                this.setState({
                    nome:'',
                    senha:'',
                    confirma:'',
                })
                toast.success("Novo registro incluído com sucesso!")
            });
            
        } catch (error) {
            toast.error("Ocorreu um erro ao tentar registrar sua empresa." + error)
        }    
    }     

    render() {

        return ( 
            <body className="hold-transition login-page">
                <div className="card">
                    <div className="card-body login-card-body">
                        <div className="login-box">
                            <div className="login-logo">
                                <a href="/login"><b>Ws</b>Lavanderia</a>
                            </div>                    
                        </div>
                        
                        <p className="login-box-msg">Informe usuário e senha de acesso.</p>
                        <form onSubmit={ this.handleRegistrar }>
                            
                            <div className="input-group mb-3">
                                  
                                <input type="email" className="form-control" name="nome" placeholder="Informe o seu email de acesso" value={ this.state.nome} onChange={ e => this.setState({ nome: e.target.value })}/>
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope"></span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="input-group mb-3">
                                <input type="password" className="form-control" name="senha" placeholder="Digite sua senha" value={ this.state.senha} onChange={ e => this.setState({ senha: e.target.value })}/>
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input type="password" className="form-control" name="confirmasenha" placeholder="Confirme sua Senha" value={ this.state.confirma} onChange={ e => this.setState({ confirma: e.target.value })}/>
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <button type="submit" className="btn btn-primary btn-block">Registrar</button>
                                </div>                                    
                            </div>
                        </form>      
                        <div className="input-group mb-3">
                            <Link onClick={ this.handleLogin }>Voltar ao Login</Link>
                        </div>
                                               
                    </div>
                </div>
                <Mensagem />
            </body>
        )
    }
}

export default Registro;